{
  "about.blocks": "Servere moderate",
  "about.contact": "Contact:",
  "about.default_locale": "Standard",
  "about.domain_blocks.no_reason_available": "Motivul nu este disponibil",
  "about.domain_blocks.preamble": "Mastodon îți permite în general să vezi conținut de la și să interacționezi cu utilizatori de pe oricare server în fediverse. Acestea sunt excepțiile care au fost făcute pe acest server.",
  "about.domain_blocks.silenced.explanation": "În general, nu vei vedea profiluri și conținut de pe acest server, cu excepția cazului în care îl cauți în mod explicit sau optezi pentru el prin urmărire.",
  "about.domain_blocks.silenced.title": "Limitat",
  "about.domain_blocks.suspended.explanation": "Nicio informație de la acest server nu va fi procesată, stocată sau trimisă, făcând imposibilă orice interacțiune sau comunicare cu utilizatorii de pe acest server.",
  "about.domain_blocks.suspended.title": "Suspendat",
  "about.language_label": "Limbă",
  "about.not_available": "Această informație nu a fost pusă la dispoziție pe acest server.",
  "about.powered_by": "Media socială descentralizată furnizată de {mastodon}",
  "about.rules": "Reguli server",
  "account.account_note_header": "Notă personală",
  "account.activity": "Activități",
  "account.add_note": "Adaugă o notă personală",
  "account.add_or_remove_from_list": "Adaugă sau elimină din liste",
  "account.badges.admin": "Admin",
  "account.badges.blocked": "Blocat",
  "account.badges.bot": "Robot",
  "account.badges.domain_blocked": "Domeniu blocat",
  "account.badges.group": "Grup",
  "account.badges.muted": "Silențios",
  "account.badges.muted_until": "Silențios până la {until}",
  "account.block": "Blochează pe @{name}",
  "account.block_domain": "Blochează domeniul {domain}",
  "account.block_short": "Blochează",
  "account.blocked": "Blocat",
  "account.cancel_follow_request": "Retrage cererea de urmărire",
  "account.copy": "Copiază link-ul profilului",
  "account.direct": "Menționează pe @{name} în privat",
  "account.disable_notifications": "Nu îmi mai trimite notificări când postează @{name}",
  "account.edit_note": "Editare notă personală",
  "account.edit_profile": "Modifică profilul",
  "account.edit_profile_short": "Editare",
  "account.enable_notifications": "Trimite-mi o notificare când postează @{name}",
  "account.endorse": "Promovează pe profil",
  "account.follow": "Urmărește",
  "account.follow_back": "Urmăreşte înapoi",
  "account.followers": "Urmăritori",
  "account.followers.empty": "Acest utilizator nu are încă urmăritori.",
  "account.followers_counter": "{count, plural, one {{counter} urmăritor} few {{counter} urmăritori} other {{counter} urmăritori}}",
  "account.following": "Urmăriți",
  "account.following_counter": "{count, plural, one {{counter} urmărit} few {{counter} urmărit} other {{counter} urmărit}}",
  "account.follows.empty": "Momentan acest utilizator nu are niciun abonament.",
  "account.go_to_profile": "Mergi la profil",
  "account.hide_reblogs": "Ascunde distribuirile de la @{name}",
  "account.in_memoriam": "În Memoriam.",
  "account.joined_short": "Înscris",
  "account.languages": "Schimbă limbile abonate",
  "account.link_verified_on": "Proprietatea acestui link a fost verificată pe {date}",
  "account.locked_info": "Acest profil este privat. Această persoană aprobă manual conturile care se abonează la ea.",
  "account.media": "Media",
  "account.mention": "Menționează pe @{name}",
  "account.moved_to": "{name} a indicat că noul său cont este acum:",
  "account.mute": "Pune pe @{name} pe silențios",
  "account.mute_notifications_short": "Amuțește notificările",
  "account.mute_short": "Ignoră",
  "account.muted": "Pus pe silențios",
  "account.no_bio": "Nicio descriere furnizată.",
  "account.open_original_page": "Deschide pagina originală",
  "account.posts": "Postări",
  "account.report": "Raportează pe @{name}",
  "account.requested_follow": "{name} A cerut să vă urmărească",
  "account.share": "Distribuie profilul lui @{name}",
  "account.show_reblogs": "Afișează distribuirile de la @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} postare} few {{counter} postări} other {{counter} postări}}",
  "account.unblock": "Deblochează pe @{name}",
  "account.unblock_domain": "Deblochează domeniul {domain}",
  "account.unblock_short": "Deblochează",
  "account.unendorse": "Nu promova pe profil",
  "account.unfollow": "Nu mai urmări",
  "account.unmute": "Nu mai ignora pe @{name}",
  "account.unmute_notifications_short": "Dezamuțire notificări",
  "account.unmute_short": "Reafișare",
  "admin.dashboard.daily_retention": "Rata de retenţie a utilizatorului pe zi după înregistrare",
  "admin.dashboard.monthly_retention": "Rata de retenţie a utilizatorului după luna de înscriere",
  "admin.dashboard.retention.average": "În medie",
  "admin.dashboard.retention.cohort": "Înregistrări lunar",
  "admin.dashboard.retention.cohort_size": "Utilizatori noi",
  "admin.impact_report.instance_followers": "Urmăritori pe care utilizatorii noștri i-ar pierde",
  "admin.impact_report.instance_follows": "Urmăritori pe care utilizatorii lor i-ar pierde",
  "admin.impact_report.title": "Rezumatul impactului",
  "alert.rate_limited.message": "Vă rugăm să reîncercați după {retry_time, time, medium}.",
  "alert.rate_limited.title": "Debit limitat",
  "alert.unexpected.message": "A apărut o eroare neașteptată.",
  "alert.unexpected.title": "Ups!",
  "alt_text_badge.title": "Text alternativ",
  "announcement.announcement": "Anunț",
  "annual_report.summary.most_used_app.most_used_app": "cea mai utilizată aplicație",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "cel mai utilizat hashtag",
  "annual_report.summary.new_posts.new_posts": "postări noi",
  "attachments_list.unprocessed": "(neprocesate)",
  "audio.hide": "Ascunde audio",
  "boost_modal.combo": "Poți apăsa {combo} pentru a sări peste asta data viitoare",
  "bundle_column_error.copy_stacktrace": "Copiază raportul de eroare",
  "bundle_column_error.error.body": "Pagina solicitată nu a putut fi randată. Ar putea fi cauzată de o eroare în codul nostru sau de o problemă de compatibilitate cu browser-ul.",
  "bundle_column_error.error.title": "Vai Nu!",
  "bundle_column_error.network.body": "A apărut o eroare la încărcarea acestei pagini. Acest lucru se poate datora unei probleme temporare cu conexiunea la internet sau cu acest server.",
  "bundle_column_error.network.title": "Eroare de rețea",
  "bundle_column_error.retry": "Încearcă din nou",
  "bundle_column_error.return": "Înapoi acasă",
  "bundle_column_error.routing.body": "Pagina solicitată nu a putut fi găsită. Ești sigur că adresa URL din bara de adrese este corectă?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Închide",
  "bundle_modal_error.retry": "Încearcă din nou",
  "closed_registrations.other_server_instructions": "Deoarece Mastodon este descentralizat, poți crea un cont pe un alt server și încă poți interacționa cu acesta.",
  "closed_registrations_modal.description": "Crearea unui cont pe {domain} nu este posibilă momentan, dar aveți în vedere că nu aveți nevoie de un cont specific pe {domain} pentru a utiliza Mastodon.",
  "closed_registrations_modal.find_another_server": "Caută un alt server",
  "closed_registrations_modal.preamble": "Mastodon este descentralizat, deci indiferent unde îți creezi contul, vei putea urmări și interacționa cu oricine de pe acest server. Poți chiar să te găzduiești de unul singur!",
  "closed_registrations_modal.title": "Înscrie-te pe Mastodon",
  "column.about": "Despre",
  "column.blocks": "Utilizatori blocați",
  "column.bookmarks": "Marcaje",
  "column.community": "Cronologie locală",
  "column.direct": "Mențiuni private",
  "column.directory": "Explorează profiluri",
  "column.domain_blocks": "Domenii blocate",
  "column.favourites": "Favorite",
  "column.firehose": "Fluxuri live",
  "column.follow_requests": "Cereri de abonare",
  "column.home": "Acasă",
  "column.lists": "Liste",
  "column.mutes": "Utilizatori ignorați",
  "column.notifications": "Notificări",
  "column.pins": "Postări fixate",
  "column.public": "Cronologie globală",
  "column_back_button.label": "Înapoi",
  "column_header.hide_settings": "Ascunde setările",
  "column_header.moveLeft_settings": "Mută coloana la stânga",
  "column_header.moveRight_settings": "Mută coloana la dreapta",
  "column_header.pin": "Fixează",
  "column_header.show_settings": "Afișare setări",
  "column_header.unpin": "Anulează fixarea",
  "community.column_settings.local_only": "Doar local",
  "community.column_settings.media_only": "Doar media",
  "community.column_settings.remote_only": "Doar la distanţă",
  "compose.language.change": "Schimbare limbă",
  "compose.language.search": "Căutare limbi…",
  "compose.published.body": "Postare publicată.",
  "compose.published.open": "Deschide",
  "compose.saved.body": "Postare salvată.",
  "compose_form.direct_message_warning_learn_more": "Află mai multe",
  "compose_form.encryption_warning": "Postările pe Mastodon nu sunt criptate în ambele părți. Nu împărtășiți nici o informație sensibilă pe Mastodon.",
  "compose_form.hashtag_warning": "Această postare nu va fi listată sub niciun hashtag, deoarece nu este publică. Doar postările publice pot fi căutate de hashtag.",
  "compose_form.lock_disclaimer": "Contul tău nu este {locked}. Oricine se poate abona la tine pentru a îți vedea postările numai pentru abonați.",
  "compose_form.lock_disclaimer.lock": "privat",
  "compose_form.placeholder": "La ce te gândești?",
  "compose_form.poll.duration": "Durata sondajului",
  "compose_form.poll.multiple": "Alegeri multiple",
  "compose_form.poll.option_placeholder": "Opțiune {number}",
  "compose_form.poll.switch_to_multiple": "Modifică sondajul pentru a permite mai multe opțiuni",
  "compose_form.poll.switch_to_single": "Modifică sondajul pentru a permite o singură opțiune",
  "compose_form.poll.type": "Stil",
  "compose_form.publish": "Postare",
  "compose_form.reply": "Răspundeți",
  "compose_form.save_changes": "Actualizare",
  "compose_form.spoiler.marked": "Elimină avertismentul privind conținutul",
  "compose_form.spoiler.unmarked": "Adaugă un avertisment privind conținutul",
  "compose_form.spoiler_placeholder": "Atenționare de conținut (opțional)",
  "confirmation_modal.cancel": "Anulează",
  "confirmations.block.confirm": "Blochează",
  "confirmations.delete.confirm": "Elimină",
  "confirmations.delete.message": "Ești sigur că vrei să elimini această postare?",
  "confirmations.delete_list.confirm": "Elimină",
  "confirmations.delete_list.message": "Ești sigur că vrei să elimini definitiv această listă?",
  "confirmations.discard_edit_media.confirm": "Renunță",
  "confirmations.discard_edit_media.message": "Ai modificări nesalvate în descrierea sau previzualizarea media, renunți oricum?",
  "confirmations.logout.confirm": "Deconectare",
  "confirmations.logout.message": "Ești sigur că vrei să te deconectezi?",
  "confirmations.mute.confirm": "Ignoră",
  "confirmations.redraft.confirm": "Șterge și scrie din nou",
  "confirmations.unfollow.confirm": "Dezabonează-te",
  "conversation.delete": "Șterge conversația",
  "conversation.mark_as_read": "Marchează ca citit",
  "conversation.open": "Vizualizează conversația",
  "conversation.with": "Cu {names}",
  "copy_icon_button.copied": "Copiat în clipboard",
  "copypaste.copied": "Copiat",
  "copypaste.copy_to_clipboard": "Copiază în clipboard",
  "directory.federated": "Din fediversul cunoscut",
  "directory.local": "Doar din {domain}",
  "directory.new_arrivals": "Înscriși recent",
  "directory.recently_active": "Activi recent",
  "disabled_account_banner.account_settings": "Setări cont",
  "disabled_account_banner.text": "Contul tău {disabledAccount} este momentan dezactivat.",
  "dismissable_banner.community_timeline": "Acestea sunt cele mai recente postări publice de la persoane ale căror conturi sunt găzduite de {domain}.",
  "dismissable_banner.dismiss": "Renunțare",
  "embed.instructions": "Integrează această postare în site-ul tău copiind codul de mai jos.",
  "embed.preview": "Iată cum va arăta:",
  "emoji_button.activity": "Activități",
  "emoji_button.clear": "Ștergeți",
  "emoji_button.custom": "Personalizați",
  "emoji_button.flags": "Steaguri",
  "emoji_button.food": "Alimente și băuturi",
  "emoji_button.label": "Inserează un emoji",
  "emoji_button.nature": "Natură",
  "emoji_button.not_found": "Nu au fost găsite emoji-uri",
  "emoji_button.objects": "Obiecte",
  "emoji_button.people": "Persoane",
  "emoji_button.recent": "Utilizați frecvent",
  "emoji_button.search": "Căutare...",
  "emoji_button.search_results": "Rezultatele căutării",
  "emoji_button.symbols": "Simboluri",
  "emoji_button.travel": "Călătorii și locuri",
  "empty_column.account_suspended": "Cont suspendat",
  "empty_column.account_timeline": "Nicio postare aici!",
  "empty_column.account_unavailable": "Profil indisponibil",
  "empty_column.blocks": "Momentan nu ai blocat niciun utilizator.",
  "empty_column.bookmarked_statuses": "Momentan nu ai nicio postare marcată. Când vei marca una, va apărea aici.",
  "empty_column.community": "Nu există nimic în cronologia locală. Postează ceva public pentru a sparge gheața!",
  "empty_column.domain_blocks": "Momentan nu există domenii blocate.",
  "empty_column.explore_statuses": "Nimic nu figurează în tendințe în acest moment. Verifică din nou mai târziu!",
  "empty_column.follow_requests": "Momentan nu ai nicio cerere de abonare. Când vei primi una, va apărea aici.",
  "empty_column.followed_tags": "Încă nu urmăriți niciun harstag -uri. Când o vei face, vor apărea aici.",
  "empty_column.hashtag": "Acest hashtag încă nu a fost folosit.",
  "empty_column.home": "Nu există nimic în cronologia ta! Abonează-te la mai multe persoane pentru a o umple. {suggestions}",
  "empty_column.list": "Momentan nu există nimic în această listă. Când membrii ei vor posta ceva nou, vor apărea aici.",
  "empty_column.mutes": "Momentan nu ai ignorat niciun utilizator.",
  "empty_column.notifications": "Momentan nu ai nicio notificare. Când alte persoane vor interacționa cu tine, îl vei vedea aici.",
  "empty_column.public": "Nu există nimic aici! Postează ceva public, sau abonează-te manual la utilizatori din alte servere pentru a umple cronologia",
  "error.unexpected_crash.explanation": "Din cauza unei erori în codul nostru sau a unei probleme de compatibilitate cu navigatorul, această pagină nu a putut fi afișată corect.",
  "error.unexpected_crash.explanation_addons": "Pagina nu a putut fi afișată corect. Această eroare este cel mai probabil cauzată de o extensie a navigatorului sau de instrumente de traducere automată.",
  "error.unexpected_crash.next_steps": "Încearcă să reîmprospătezi pagina. Dacă tot nu funcționează, poți accesa Mastodon dintr-un alt navigator sau dintr-o aplicație nativă.",
  "error.unexpected_crash.next_steps_addons": "Încearcă să le dezactivezi și să reîmprospătezi pagina. Dacă tot nu funcționează, poți accesa Mastodon dintr-un alt navigator sau dintr-o aplicație nativă.",
  "errors.unexpected_crash.copy_stacktrace": "Copiere stacktrace în clipboard",
  "errors.unexpected_crash.report_issue": "Raportează o problemă",
  "explore.suggested_follows": "Persoane",
  "explore.trending_links": "Noutăți",
  "explore.trending_statuses": "Postări",
  "explore.trending_tags": "Hastaguri",
  "featured_carousel.current": "<sr>Postare</sr> {current, number} / {max, number}",
  "featured_carousel.slide": "Postarea {current, number} din {max, number}",
  "filter_modal.added.context_mismatch_explanation": "Această categorie de filtre nu se aplică în contextul în care ați accesat acestă postare. Dacă doriți ca postarea să fie filtrată și în acest context, va trebui să editați filtrul.",
  "filter_modal.added.context_mismatch_title": "Nepotrivire contextuală!",
  "filter_modal.added.expired_explanation": "Această categorie de filtre a expirat, va trebui să modifici data de expirare pentru ca aceasta să se aplice.",
  "filter_modal.added.expired_title": "Filtru expirat!",
  "filter_modal.added.review_and_configure": "Pentru a revizui și a configura în continuare această categorie de filtre, mergi la {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Configurări pentru filtre",
  "filter_modal.added.settings_link": "pagina configurărilor",
  "filter_modal.added.short_explanation": "Această postare a fost adăugată la următoarea categorie de filtre: {title}.",
  "filter_modal.added.title": "Filtru adăugat!",
  "filter_modal.select_filter.context_mismatch": "nu se aplică acestui context",
  "filter_modal.select_filter.expired": "expirat",
  "filter_modal.select_filter.prompt_new": "Categorie nouă: {name}",
  "filter_modal.select_filter.search": "Caută sau creează",
  "filter_modal.select_filter.subtitle": "Folosește o categorie existentă sau creează una nouă",
  "filter_modal.select_filter.title": "Filtrează această postare",
  "filter_modal.title.status": "Filtrează o postare",
  "firehose.all": "Toate",
  "firehose.local": "Acest Server",
  "firehose.remote": "Alte servere",
  "follow_request.authorize": "Acceptă",
  "follow_request.reject": "Respinge",
  "follow_requests.unlocked_explanation": "Chiar dacă contul tău nu este blocat, personalul {domain} a considerat că ai putea prefera să consulți manual cererile de abonare de la aceste conturi.",
  "follow_suggestions.dismiss": "Nu mai afișa din nou",
  "follow_suggestions.personalized_suggestion": "Sugestie personalizată",
  "follow_suggestions.popular_suggestion": "Sugestie populară",
  "follow_suggestions.view_all": "Vizualizați tot",
  "follow_suggestions.who_to_follow": "Pe cine să urmăriți",
  "followed_tags": "Hastaguri urmărite",
  "footer.about": "Despre",
  "footer.directory": "Catalogul de profiluri",
  "footer.get_app": "Obține aplicația",
  "footer.keyboard_shortcuts": "Comenzi rapide de la tastatură",
  "footer.privacy_policy": "Politica de confidenţialitate",
  "footer.source_code": "Vizualizează codul sursă",
  "footer.status": "Status",
  "getting_started.heading": "Primii pași",
  "hashtag.column_header.tag_mode.all": "și {additional}",
  "hashtag.column_header.tag_mode.any": "sau {additional}",
  "hashtag.column_header.tag_mode.none": "fără {additional}",
  "hashtag.column_settings.select.no_options_message": "Nu s-au găsit sugestii",
  "hashtag.column_settings.select.placeholder": "Introdu hashtag-uri…",
  "hashtag.column_settings.tag_mode.all": "Toate acestea",
  "hashtag.column_settings.tag_mode.any": "Oricare din acestea",
  "hashtag.column_settings.tag_mode.none": "Niciuna dintre acestea",
  "hashtag.column_settings.tag_toggle": "Adaugă etichete suplimentare pentru această coloană",
  "hashtag.follow": "Urmărește haștagul",
  "hashtag.unfollow": "Nu mai urmări haștagul",
  "home.column_settings.show_reblogs": "Afișează distribuirile",
  "home.column_settings.show_replies": "Afișează răspunsurile",
  "home.hide_announcements": "Ascunde anunțurile",
  "home.pending_critical_update.body": "Te rugăm să-ți actualizezi serverul de Mastodon cat mai curând posibil!",
  "home.pending_critical_update.link": "Vezi noutăți",
  "home.pending_critical_update.title": "Actualizare critică de securitate disponibilă!",
  "home.show_announcements": "Afișează anunțurile",
  "interaction_modal.on_another_server": "Pe un alt server",
  "interaction_modal.on_this_server": "Pe acest server",
  "intervals.full.days": "{number, plural, one {o zi} few {# zile} other {# de zile}}",
  "intervals.full.hours": "{number, plural, one {o oră} few {# ore} other {# de ore}}",
  "intervals.full.minutes": "{number, plural, one {un minut} few {# minute} other {# de minute}}",
  "keyboard_shortcuts.back": "Navighează înapoi",
  "keyboard_shortcuts.blocked": "Deschide lista utilizatorilor blocați",
  "keyboard_shortcuts.boost": "Distribuie postarea",
  "keyboard_shortcuts.column": "Focalizează pe coloană",
  "keyboard_shortcuts.compose": "Focalizează pe zona de text",
  "keyboard_shortcuts.description": "Descriere",
  "keyboard_shortcuts.down": "Coboară în listă",
  "keyboard_shortcuts.enter": "Deschide postarea",
  "keyboard_shortcuts.federated": "Afișează cronologia globală",
  "keyboard_shortcuts.heading": "Comenzi rapide ale tastaturii",
  "keyboard_shortcuts.home": "Afișează cronologia principală",
  "keyboard_shortcuts.hotkey": "Tastă rapidă",
  "keyboard_shortcuts.legend": "Afișează această legendă",
  "keyboard_shortcuts.local": "Deschide cronologia locală",
  "keyboard_shortcuts.mention": "Menționează autorul",
  "keyboard_shortcuts.muted": "Deschide lista utilizatorilor ignorați",
  "keyboard_shortcuts.my_profile": "Afișează propriul profil",
  "keyboard_shortcuts.notifications": "Deschide coloana cu notificări",
  "keyboard_shortcuts.open_media": "Deschide media",
  "keyboard_shortcuts.pinned": "Deschide lista postărilor fixate",
  "keyboard_shortcuts.profile": "Afișează profilul autorului",
  "keyboard_shortcuts.reply": "Răspunde la postare",
  "keyboard_shortcuts.requests": "Deschide lista de cereri de abonare",
  "keyboard_shortcuts.search": "Focalizează pe bara de căutare",
  "keyboard_shortcuts.spoilers": "Afișează/ascunde câmpul CW",
  "keyboard_shortcuts.start": "Deschide coloana \"Primii pași\"",
  "keyboard_shortcuts.toggle_hidden": "Afișează/ascunde textul din spatele CW",
  "keyboard_shortcuts.toggle_sensitivity": "Afișează/ascunde media",
  "keyboard_shortcuts.toot": "Începe o postare nouă",
  "keyboard_shortcuts.unfocus": "Părăsește zona de text/bara de căutare",
  "keyboard_shortcuts.up": "Urcă în listă",
  "lightbox.close": "Închide",
  "lightbox.next": "Înainte",
  "lightbox.previous": "Înapoi",
  "limited_account_hint.action": "Afișează profilul oricum",
  "link_preview.author": "De {name}",
  "lists.delete": "Șterge lista",
  "lists.edit": "Modifică lista",
  "lists.replies_policy.followed": "Tuturor persoanelor la care te-ai abonat",
  "lists.replies_policy.list": "Membrilor din listă",
  "lists.replies_policy.none": "Nu afișa nimănui",
  "load_pending": "{count, plural, one {# element nou} other {# elemente noi}}",
  "moved_to_account_banner.text": "Contul tău {disabledAccount} este în acest moment dezactivat deoarece te-ai mutat la {movedToAccount}.",
  "navigation_bar.about": "Despre",
  "navigation_bar.advanced_interface": "Deschide în interfața web avansată",
  "navigation_bar.blocks": "Utilizatori blocați",
  "navigation_bar.bookmarks": "Marcaje",
  "navigation_bar.domain_blocks": "Domenii blocate",
  "navigation_bar.filters": "Cuvinte ignorate",
  "navigation_bar.follow_requests": "Cereri de abonare",
  "navigation_bar.followed_tags": "Hashtag-uri urmărite",
  "navigation_bar.follows_and_followers": "Abonamente și abonați",
  "navigation_bar.lists": "Liste",
  "navigation_bar.logout": "Deconectare",
  "navigation_bar.mutes": "Utilizatori ignorați",
  "navigation_bar.opened_in_classic_interface": "Postările, conturile și alte pagini specifice sunt deschise implicit în interfața web clasică.",
  "navigation_bar.preferences": "Preferințe",
  "navigation_bar.search": "Caută",
  "not_signed_in_indicator.not_signed_in": "Trebuie să te conectezi pentru a accesa această resursă.",
  "notification.admin.report": "{name} a raportat pe {target}",
  "notification.admin.sign_up": "{name} s-a înscris",
  "notification.favourite": "{name} a adăugat postarea ta la favorite",
  "notification.follow": "{name} s-a abonat la tine",
  "notification.follow_request": "{name} a trimis o cerere de abonare",
  "notification.own_poll": "Sondajul tău s-a încheiat",
  "notification.reblog": "{name} ți-a distribuit postarea",
  "notification.status": "{name} tocmai a postat",
  "notification.update": "{name} și-a modificat o postare",
  "notifications.clear": "Șterge notificările",
  "notifications.clear_confirmation": "Ești sigur că vrei să ștergi permanent toate notificările?",
  "notifications.column_settings.admin.report": "Raportări noi:",
  "notifications.column_settings.admin.sign_up": "Înscrieri noi:",
  "notifications.column_settings.alert": "Notificări pe desktop",
  "notifications.column_settings.follow": "Noi urmăritori:",
  "notifications.column_settings.follow_request": "Noi cereri de abonare:",
  "notifications.column_settings.mention": "Mențiuni:",
  "notifications.column_settings.poll": "Rezultate sondaj:",
  "notifications.column_settings.push": "Notificări push",
  "notifications.column_settings.reblog": "Distribuiri:",
  "notifications.column_settings.show": "Afișează în coloană",
  "notifications.column_settings.sound": "Redare sunet",
  "notifications.column_settings.status": "Postări noi:",
  "notifications.column_settings.unread_notifications.category": "Notificări necitite",
  "notifications.column_settings.unread_notifications.highlight": "Evidențiază notificările necitite",
  "notifications.column_settings.update": "Modificări:",
  "notifications.filter.all": "Toate",
  "notifications.filter.boosts": "Distribuiri",
  "notifications.filter.follows": "Abonați",
  "notifications.filter.mentions": "Mențiuni",
  "notifications.filter.polls": "Rezultate sondaj",
  "notifications.filter.statuses": "Noutăți de la persoanele la care ești abonat",
  "notifications.grant_permission": "Acordă permisiunea.",
  "notifications.group": "{count} notificări",
  "notifications.mark_as_read": "Marchează toate notificările ca citite",
  "notifications.permission_denied": "Notificările pe desktop nu sunt disponibile deoarece cererea de permisiuni a navigatorului a fost respinsă",
  "notifications.permission_denied_alert": "Notificările pe desktop nu pot fi activate, deoarece permisiunea navigatorului a fost refuzată înainte",
  "notifications.permission_required": "Notificările pe desktop nu sunt disponibile deoarece permisiunea necesară nu a fost acordată.",
  "notifications_permission_banner.enable": "Activează notificările pe desktop",
  "notifications_permission_banner.how_to_control": "Pentru a primi notificări când Mastodon nu este deschis, activează notificările pe desktop. Poți controla exact ce tipuri de interacțiuni generează notificări pe desktop apăsând pe butonul {icon} de mai sus odată ce sunt activate.",
  "notifications_permission_banner.title": "Rămâne la curent",
  "onboarding.follows.empty": "Din păcate, nu pot fi afișate rezultate chiar acum. Poți încerca să cauți sau să navighezi pe pagina de explorare pentru a găsi oameni pe care să-i urmărești sau încearcă iar mai târziu.",
  "picture_in_picture.restore": "Pune-l înapoi",
  "poll.closed": "Închis",
  "poll.refresh": "Reîncarcă",
  "poll.reveal": "Vezi rezultatele",
  "poll.total_people": "{count, plural, one {# persoană} other {# persoane}}",
  "poll.total_votes": "{count, plural, one {# vot} other {# voturi}}",
  "poll.vote": "Votează",
  "poll.voted": "Ai votat pentru acest răspuns",
  "poll.votes": "{votes, plural, one {# vot} other {# voturi}}",
  "poll_button.add_poll": "Adaugă un sondaj",
  "poll_button.remove_poll": "Elimină sondajul",
  "privacy.change": "Modifică confidențialitatea postării",
  "privacy.public.short": "Public",
  "privacy_policy.last_updated": "Ultima actualizare în data de {date}",
  "privacy_policy.title": "Politică de confidențialitate",
  "refresh": "Reîncarcă",
  "relative_time.days": "{number}z",
  "relative_time.full.days": "acum {number, plural, one {o zi} few {# zile} other {# de zile}}",
  "relative_time.full.hours": "acum {number, plural, one {o oră} few {# ore} other {# de ore}}",
  "relative_time.full.just_now": "chiar acum",
  "relative_time.full.minutes": "acum {number, plural, one {un minut} few {# minute} other {# de minute}}",
  "relative_time.full.seconds": "acum {number, plural, one {o secundă} few {# secunde} other {# de secunde}}",
  "relative_time.hours": "{number}o",
  "relative_time.just_now": "acum",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "astăzi",
  "reply_indicator.cancel": "Anulează",
  "report.block": "Blochează",
  "report.block_explanation": "Nu îi vei mai vedea postările. Nu va mai putea să îți vadă postările sau să ți se aboneze. Va putea să își dea seama că a fost blocat·ă.",
  "report.categories.other": "Altele",
  "report.categories.spam": "Mesaje nedorite",
  "report.categories.violation": "Conținutul încalcă una sau mai multe dintre regulile serverului",
  "report.category.subtitle": "Alege varianta care se potrivește cel mai bine",
  "report.close": "Gata",
  "report.comment.title": "Mai este ceva important pe care ai vrea să ni-l spui?",
  "report.forward": "Redirecționează către {target}",
  "report.forward_hint": "Acest cont este de pe un alt server. Trimitem o copie anonimă a raportului și acolo?",
  "report.mute": "Pune pe silențios",
  "report.mute_explanation": "Nu îi vei mai vedea postările. Va mai putea să îți vadă postările sau să ți se aboneze și nu va putea să își dea seama că a fost pus·ă pe silențios.",
  "report.next": "Înainte",
  "report.placeholder": "Comentarii adiționale",
  "report.reasons.dislike": "Nu-mi place",
  "report.reasons.dislike_description": "Nu este ceva ce ai vrea să vezi",
  "report.reasons.legal": "Este ilegal",
  "report.reasons.legal_description": "Crezi că încalcă legea țării tale sau a serverului",
  "report.reasons.other": "Este altceva",
  "report.reasons.other_description": "Problema nu se încadrează în vreuna dintre categoriile de mai sus",
  "report.reasons.spam": "Este spam",
  "report.reasons.spam_description": "Linkuri malițioase, reclame false sau mesaje care se tot repetă",
  "report.reasons.violation": "Încalcă regulile serverului",
  "report.reasons.violation_description": "Știi că încalcă anumite reguli specifice",
  "report.rules.subtitle": "Selectează toate variantele care se aplică",
  "report.rules.title": "Care reguli sunt încălcate?",
  "report.statuses.subtitle": "Selectează toate variantele care se aplică",
  "report.statuses.title": "Există vreo postare care să susțină această raportare?",
  "report.submit": "Trimite",
  "report.target": "Raportează {target}",
  "report.thanks.take_action": "Aici poți controla ceea ce vezi pe Mastodon:",
  "report.thanks.take_action_actionable": "Cât timp consultăm raportarea ta, poți să iei măsuri împotriva @{name}:",
  "report.thanks.title": "Nu vrei să vezi aceste lucruri?",
  "report.thanks.title_actionable": "Îți mulțumim pentru raportare, o vom analiza în curând.",
  "report.unfollow": "Dezabonează-te de la @{name}",
  "report.unfollow_explanation": "Ești abonat acestui cont. Pentru a nu-i mai vedea postările în cronologia ta principală, dezabonează-te.",
  "report_notification.attached_statuses": "{count, plural, one {o postare legată} few {{count} postări legate} other {{count} de postări legate}}",
  "report_notification.categories.other": "Altele",
  "report_notification.categories.spam": "Mesaje nedorite",
  "report_notification.categories.violation": "Încălcare a regulilor",
  "report_notification.open": "Deschide raportarea",
  "search.no_recent_searches": "Nicio căutare recentă",
  "search.placeholder": "Caută",
  "search.quick_action.account_search": "Profiluri care se potrivesc cu {x}",
  "search.quick_action.open_url": "Deschide adresa în Mastodon",
  "search.quick_action.status_search": "Postări care se potrivesc cu {x}",
  "search.search_or_paste": "Caută sau lipește un URL",
  "search_popout.full_text_search_disabled_message": "Indisponibil pe {domain}.",
  "search_popout.language_code": "Cod de limbă ISO",
  "search_popout.options": "Opțiuni de căutare",
  "search_popout.quick_actions": "Acțiuni rapide",
  "search_popout.recent": "Căutări recente",
  "search_popout.specific_date": "data specifică",
  "search_popout.user": "utilizator",
  "search_results.accounts": "Profiluri",
  "search_results.all": "Toate",
  "search_results.hashtags": "Hashtag-uri",
  "search_results.see_all": "Vezi tot",
  "search_results.statuses": "Postări",
  "server_banner.about_active_users": "Persoane care au folosit acest server în ultimele 30 de zile (Utilizatori Lunari Activi)",
  "server_banner.active_users": "utilizatori activi",
  "server_banner.administered_by": "Administrat de:",
  "server_banner.server_stats": "Statisticile serverului:",
  "sign_in_banner.create_account": "Creează-ți un cont",
  "sign_in_banner.sign_in": "Conectează-te",
  "sign_in_banner.sso_redirect": "Conectează-te sau Înregistrează-te",
  "status.admin_account": "Deschide interfața de moderare pentru @{name}",
  "status.admin_status": "Deschide această stare în interfața de moderare",
  "status.block": "Blochează pe @{name}",
  "status.bookmark": "Marchează",
  "status.cancel_reblog_private": "Repuls",
  "status.cannot_reblog": "Această postare nu poate fi distribuită",
  "status.copy": "Copiează link-ul postării",
  "status.delete": "Șterge",
  "status.detailed_status": "Conversația detaliată",
  "status.direct": "Menționează @{name} în privat",
  "status.direct_indicator": "Mențiune privată",
  "status.edit": "Modifică",
  "status.edited_x_times": "Modificată {count, plural, one {o dată} few {de {count} ori} other {de {count} de ori}}",
  "status.filter": "Filtrează această postare",
  "status.history.created": "creată de {name} pe {date}",
  "status.history.edited": "modificată de {name} pe {date}",
  "status.load_more": "Încarcă mai multe",
  "status.media.open": "Click pentru a deschide",
  "status.media.show": "Click pentru a afișa",
  "status.media_hidden": "Media ascunsă",
  "status.mention": "Menționează pe @{name}",
  "status.more": "Mai mult",
  "status.mute": "Ignoră pe @{name}",
  "status.mute_conversation": "Ignoră conversația",
  "status.open": "Extinde această stare",
  "status.pin": "Fixează pe profil",
  "status.read_more": "Citește mai mult",
  "status.reblog": "Impuls",
  "status.reblogged_by": "{name} a distribuit",
  "status.reblogs.empty": "Nimeni nu a distribuit această postare până acum. Când cineva o va face, va apărea aici.",
  "status.redraft": "Șterge și adaugă la ciorne",
  "status.remove_bookmark": "Îndepărtează marcajul",
  "status.replied_to": "Răspunde-i lui {name}",
  "status.reply": "Răspunde",
  "status.replyAll": "Răspunde la discuție",
  "status.report": "Raportează pe @{name}",
  "status.sensitive_warning": "Conținut sensibil",
  "status.share": "Distribuie",
  "status.show_less_all": "Arată mai puțin pentru toți",
  "status.show_more_all": "Arată mai mult pentru toți",
  "status.show_original": "Afișează originalul",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "Traduce",
  "status.translated_from_with": "Tradus din {lang} folosind serviciile {provider}",
  "status.uncached_media_warning": "Previzualizarea nu este disponibilă",
  "status.unmute_conversation": "Repornește conversația",
  "status.unpin": "Eliberează din profil",
  "subscribed_languages.lead": "Doar postări în limbile selectate vor apărea în cronologia ta principală după ce efectuezi modificarea. Alege „niciuna” pentru a primi postări în orice limbă.",
  "subscribed_languages.save": "Salvează modificările",
  "subscribed_languages.target": "Modifică limbile abonate pentru {target}",
  "tabs_bar.home": "Acasă",
  "tabs_bar.notifications": "Notificări",
  "time_remaining.days": "{number, plural, one {o zi rămasă} few {# zile rămase} other {# de zile rămase}}",
  "time_remaining.hours": "{number, plural, one {o oră rămasă} few {# ore rămase} other {# de ore rămase}}",
  "time_remaining.minutes": "{number, plural, one {un minut rămas} few {# minute rămase} other {# de minute rămase}}",
  "time_remaining.moments": "Momente rămase",
  "time_remaining.seconds": "{number, plural, one {o secundă rămasă} few {# secunde rămase} other {# de secunde rămase}}",
  "trends.counter_by_accounts": "{count, plural, one {o persoană} few {{counter} persoane} other {{counter} de persoane}} în {days, plural, one {ultima zi} few {ultimele {days} zile} other {ultimele {days} de zile}}",
  "trends.trending_now": "În tendință acum",
  "ui.beforeunload": "Postarea se va pierde dacă părăsești pagina.",
  "units.short.billion": "{count}Mld",
  "units.short.million": "{count}Mln",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Trage și eliberează pentru a încărca",
  "upload_button.label": "Adaugă media (JPEG, PNG, GIF, WebM, MP4, MOV)",
  "upload_error.limit": "Limita de încărcare a fișierului a fost depășită.",
  "upload_error.poll": "Încărcarea fișierului nu este permisă cu sondaje.",
  "upload_form.edit": "Modifică",
  "upload_progress.label": "Se încarcă...",
  "upload_progress.processing": "Se procesează…",
  "username.taken": "Acel nume de utilizator este luat. Încearcă altul",
  "video.close": "Închide video",
  "video.download": "Descarcă fișierul",
  "video.exit_fullscreen": "Ieși din modul ecran complet",
  "video.expand": "Extinde video",
  "video.fullscreen": "Ecran complet",
  "video.hide": "Ascunde video",
  "video.pause": "Pauză",
  "video.play": "Redare"
}
